var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$attrs.type === 'select')?_c('b-form-select',_vm._g(_vm._b({on:{"change":(e) => _vm.on_change(e, 'change')}},'b-form-select',_vm.$attrs,false),_vm.$listeners)):_c('b-input',_vm._g(_vm._b({on:{"input":(e) => _vm.on_change(e, 'input')}},'b-input',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }